import { useCallback, useRef, useState } from "react";
import api from "../services/httpClient";
import { assertNonEmptyObject } from "../utils/assert";

export function useApiPost(path) {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const abortRef = useRef(null);

  const submit = useCallback(async (body, query = {}) => {
    assertNonEmptyObject(body);

    // Anuluj poprzedni request jeśli jeszcze trwa (cancel-on-new)
    abortRef.current?.abort();

    const controller = new AbortController();
    abortRef.current = controller;

    setIsSubmitting(true);
    setError(null);

    try {
      const resp = await api.post(path, body, {
        params: query,
        signal: controller.signal,
        headers: { "Content-Type": "application/json" },
      });
      return resp.data;
    } catch (e) {
      if (e?.name === "CanceledError" || e?.name === "AbortError") return;
      setError(e);
      throw e;
    } finally {
      // Aktualizuj stan tylko jeśli to wciąż aktualny request
      if (abortRef.current === controller) {
        abortRef.current = null;
        setIsSubmitting(false);
      }
    }
  }, [path]);

  const cancel = useCallback(() => abortRef.current?.abort(), []);

  return { submit, isSubmitting, error, cancel };
}
